import React from 'react';
import {
  Box,
  Typography,
  Paper
} from '@mui/material';
import IncomeStatementTable from '../components/charts/IncomeStatementTable';
import SavingsMetricsChart from '../components/charts/SavingsMetricsChart';

export default function Analytics() {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'grey.50' }}>
      {/* Hero Section */}
      <Paper 
        elevation={0}
        sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          p: { xs: 3, md: 4 },
          mb: 3,
          borderRadius: 0
        }}
      >
        <Box sx={{ maxWidth: '1200px', mx: 'auto' }}>
          <Typography variant="h4" sx={{ fontWeight: 700, mb: 2 }}>
            Financial Reports
          </Typography>
          <Typography variant="h6" sx={{ opacity: 0.9, fontWeight: 400 }}>
            Detailed financial statements and tabular analysis
          </Typography>
        </Box>
      </Paper>

      {/* Main Content */}
      <Box sx={{ maxWidth: '1200px', mx: 'auto', px: { xs: 2, md: 3 } }}>
        {/* Income Statement */}
        <Paper sx={{ p: 3, mb: 3, borderRadius: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 3, color: 'text.primary' }}>
            Income Statement
          </Typography>
          <IncomeStatementTable />
        </Paper>

        {/* Savings Metrics */}
        <Paper sx={{ p: 3, mb: 3, borderRadius: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 3, color: 'text.primary' }}>
            Savings Analysis
          </Typography>
          <SavingsMetricsChart />
        </Paper>
      </Box>
    </Box>
  );
}